import React from "react";
import styled from "styled-components";
import { Box, Flex } from "rebass/styled-components";
import { HiExclamation } from "react-icons/hi";

import { ClipQualityIcon } from "../Icons";
import { useClipQualityConfigs } from "MVVM/Hooks/useClipQualityConfigs";
import { useClipQualitySettingsModal } from "MVVM/Hooks/useClipQualitySettingsModal";

export const ClipQualityBubble = () => {
  const { configs, currentConfig, needsConfChange } = useClipQualityConfigs();
  const { open: openClipQualityModal } = useClipQualitySettingsModal();
  const [dismissed, setDismissed] = React.useState(false);

  if (!needsConfChange || dismissed || location.pathname === "/library")
    return null;

  const isUnset = !currentConfig;

  return (
    <BubbleContainer onClick={() => openClipQualityModal()}>
      <BubbleIcon>
        <ClipQualityIcon size={20} />
      </BubbleIcon>
      <BubbleText>
        {isUnset
          ? "Set your clip quality settings"
          : "Update your clip quality settings"}
      </BubbleText>
      {isUnset ? (
        <NewPill>NEW</NewPill>
      ) : (
        <WarningIcon>
          <HiExclamation size={14} />
        </WarningIcon>
      )}
      <DismissButton
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          setDismissed(true);
        }}
      >
        ✕
      </DismissButton>
    </BubbleContainer>
  );
};

const BubbleContainer = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy};
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  gap: 8px;
  padding: 8px 16px 8px 12px;
  transition: border-color 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.envy};
  }
`;

const BubbleIcon = styled(Flex)`
  align-items: center;
  color: ${({ theme }) => theme.colors.envy};
`;

const BubbleText = styled(Box)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: "Barlow", sans-serif;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`;

export const NewPill = styled(Box)`
  background: ${({ theme }) => theme.colors.envy};
  border-radius: 12px;
  color: white;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 6px;
  text-transform: uppercase;
`;

export const WarningIcon = styled(Flex)`
  align-items: center;
  color: #f5a623;
`;

const DismissButton = styled(Flex)`
  align-items: center;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.shade400};
  cursor: pointer;
  font-size: 12px;
  height: 20px;
  justify-content: center;
  transition: color 0.15s ease;
  width: 20px;

  &:hover {
    color: ${({ theme }) => theme.colors.ice};
  }
`;
